module.exports = __webpack_public_path__ + "static/media/arrow_up.251a3724.svg";